import React from 'react';
import SameDayCancelRuleTable from './same_day_cancel_rule_table';

const DomesticAirCancelGuide: React.FC = () => (
  <>
    <p style={{ fontWeight: 'bold', marginBottom: '10px', fontSize: 16 }}>
      国内航空券のキャンセル依頼期限について
    </p>
    <SameDayCancelRuleTable />
  </>
);

export default DomesticAirCancelGuide;
